var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GiveUpRegist.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-be5b7f6c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GiveUpRegist.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/main/member/APP/GiveUpRegist.vue
// module id = 1219
// module chunks = 6